import { render, staticRenderFns } from "./AIEmptyState.vue?vue&type=template&id=231e3d23"
import script from "./AIEmptyState.vue?vue&type=script&lang=js"
export * from "./AIEmptyState.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports